import { OnInit, EventEmitter } from '@angular/core';
import { IntegrationsService } from '@app/features/company-settings/integrations/services/integrations.service';
import { CommonService } from '@app/services';
import { Subject } from 'rxjs';
var CsToggleuserpreferenceComponent = /** @class */ (function () {
    function CsToggleuserpreferenceComponent(commonService, integrationsService) {
        this.commonService = commonService;
        this.integrationsService = integrationsService;
        this.dragEnabled = false;
        this.screenName = '';
        this.labelName = 'Try out the new view screen';
        this.oldUrl = '';
        this.newUrl = '';
        this.preferenceValue = '';
        this.betaPropertyName = '';
        this.selected_preference = new EventEmitter();
        this.integrationsUI = false;
        this.toggleSwitch = false;
        this.count = 0;
        this.feedbackEmitter$ = new Subject();
        this.reason = '';
        this.comments = '';
        this.reasons = [
            {
                'id': 1,
                'description': 'I don’t have time to get used to it right now'
            },
            {
                'id': 2,
                'description': 'There are missing features stopping me move across'
            },
            {
                'id': 3,
                'description': 'There are bugs stopping me move across'
            },
            {
                'id': 4,
                'description': 'I just don’t like it - change is hard!'
            },
            {
                'id': 5,
                'description': 'I think the new design is worse - I have constructive feedback'
            }
        ];
        this.select2Config = {
            minimumResultsForSearch: -1
        };
    }
    CsToggleuserpreferenceComponent.prototype.ngOnInit = function () {
        if (this.preferenceValue) {
            this.toggleSwitch = true;
        }
        else {
            this.toggleSwitch = false;
        }
    };
    CsToggleuserpreferenceComponent.prototype.setUserPropertyViewPreference = function (savedFeedback) {
        var _this = this;
        this.count++;
        if (!this.integrationsUI || savedFeedback) {
            if (savedFeedback) {
                this.toggleSwitch = true;
            }
            var data = {};
            data['screenName'] = this.screenName;
            if (this.preferenceValue) {
                this.toggleSwitch = false;
                data['columnValue'] = 0;
                this.commonService.saveUserNewUIPreference(data)
                    .subscribe(function (resp) {
                    window.location.href = _this.oldUrl;
                }, function (error) {
                    console.log('err', error);
                });
            }
            else if (!this.preferenceValue) {
                this.toggleSwitch = true;
                data['columnValue'] = 1;
                this.commonService.saveUserNewUIPreference(data)
                    .subscribe(function (resp) {
                    window.location.href = _this.newUrl;
                }, function (error) {
                    console.log('err', error);
                });
            }
        }
        else {
            this.showFeedbackForm = true;
            this.toggleSwitch = false;
        }
        if (this.count == 2 && this.integrationsUI && !savedFeedback) {
            this.hideFeedbackForm();
        }
    };
    CsToggleuserpreferenceComponent.prototype.hideFeedbackForm = function () {
        if (this.showFeedbackForm) {
            this.showFeedbackForm = false;
            this.toggleSwitch = true;
            this.comments = '';
            this.reason = '';
            this.count = 0;
            this.canSubmit = false;
        }
    };
    CsToggleuserpreferenceComponent.prototype.submitFeedbackForm = function () {
        var _this = this;
        if (this.canSubmit) {
            var data = {
                betaPropertyName: this.betaPropertyName,
                reason: this.reason,
                feedback: this.comments,
                uiScreen: this.screenName
            };
            this.integrationsService.updateSwitchDisableNotes(data).subscribe(function () {
                _this.setUserPropertyViewPreference(true);
                _this.showFeedbackForm = false;
            }, function () {
                return false;
            });
        }
        else {
            return false;
        }
    };
    CsToggleuserpreferenceComponent.prototype.validateFeedback = function (event) {
        this.canSubmit = false;
        this.reason = '';
        if (event) {
            var selectedEvent_1 = event;
            var selectedReason = this.reasons.find(function (x) { return x.id == selectedEvent_1; });
            this.reason = selectedReason['description'];
            this.canSubmit = this.reason.trim() !== '';
        }
    };
    return CsToggleuserpreferenceComponent;
}());
export { CsToggleuserpreferenceComponent };
